
          import "SelectableTile.styles_9kr8p.linaria.css";
          import { styled } from "@linaria/react";
import Radio from "../Radio";
import Checkbox from "../Checkbox";
export const StyledWrapper = /*#__PURE__*/styled("div")({
  name: "StyledWrapper",
  class: "s10msywl"
});
export const StyledCheckbox = /*#__PURE__*/styled(Checkbox)({
  name: "StyledCheckbox",
  class: "sohwngm"
});
export const StyledRadio = /*#__PURE__*/styled(Radio)({
  name: "StyledRadio",
  class: "s1bs3k0p"
});
export const Subcopy = /*#__PURE__*/styled("p")({
  name: "Subcopy",
  class: "s17xagsa"
});
          